!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@campfire/titular-tooltip"), require("@material-ui/core"), require("@material-ui/icons/Add"), require("@material-ui/styles"), require("react"), require("react-dropzone"), require("uuid"), require("@campfire/hover-link"), require("@material-ui/icons/Clear"), require("@material-ui/icons/Description")) : "function" == typeof define && define.amd ? define(["exports", "@campfire/titular-tooltip", "@material-ui/core", "@material-ui/icons/Add", "@material-ui/styles", "react", "react-dropzone", "uuid", "@campfire/hover-link", "@material-ui/icons/Clear", "@material-ui/icons/Description"], t) : t((e = e || self)["file-upload-gallery"] = {}, e.titularTooltip, e.core, e.Add, e.styles, e.React, e.reactDropzone, e.uuid, e.hoverLink, e.ClearIcon, e.DescriptionIcon);
}(this, function (e, t, n, r, o, a, l, i, c, u, m) {
  "use strict";

  r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
  var s = "default" in a ? a.default : a;
  u = u && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u, m = m && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m;

  var _d = function d() {
    return (_d = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  };

  function f(e, t, n, r) {
    return new (n || (n = Promise))(function (o, a) {
      function l(e) {
        try {
          c(r.next(e));
        } catch (e) {
          a(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          a(e);
        }
      }

      function c(e) {
        var t;
        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
          e(t);
        })).then(l, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  }

  function p(e, t) {
    var n,
        r,
        o,
        a,
        l = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return a = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
      return this;
    }), a;

    function i(a) {
      return function (i) {
        return function (a) {
          if (n) throw new TypeError("Generator is already executing.");

          for (; l;) try {
            if (n = 1, r && (o = 2 & a[0] ? r.return : a[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, a[1])).done) return o;

            switch (r = 0, o && (a = [2 & a[0], o.value]), a[0]) {
              case 0:
              case 1:
                o = a;
                break;

              case 4:
                return l.label++, {
                  value: a[1],
                  done: !1
                };

              case 5:
                l.label++, r = a[1], a = [0];
                continue;

              case 7:
                a = l.ops.pop(), l.trys.pop();
                continue;

              default:
                if (!(o = (o = l.trys).length > 0 && o[o.length - 1]) && (6 === a[0] || 2 === a[0])) {
                  l = 0;
                  continue;
                }

                if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                  l.label = a[1];
                  break;
                }

                if (6 === a[0] && l.label < o[1]) {
                  l.label = o[1], o = a;
                  break;
                }

                if (o && l.label < o[2]) {
                  l.label = o[2], l.ops.push(a);
                  break;
                }

                o[2] && l.ops.pop(), l.trys.pop();
                continue;
            }

            a = t.call(e, l);
          } catch (e) {
            a = [6, e], r = 0;
          } finally {
            n = o = 0;
          }

          if (5 & a[0]) throw a[1];
          return {
            value: a[0] ? a[1] : void 0,
            done: !0
          };
        }([a, i]);
      };
    }
  }

  var g = o.makeStyles(function (e) {
    var t;
    return o.createStyles({
      dialogTitle: {
        backgroundColor: "#242424"
      },
      dialogContent: {
        backgroundColor: "#242424"
      },
      divider: {
        backgroundColor: "#424242"
      },
      titleText: {
        color: "#ffffff"
      },
      fileSizeText: {
        color: "#d2d2d2",
        marginLeft: 12
      },
      closeDialogIconButton: {
        border: "1px solid #ffffff"
      },
      image: (t = {
        display: "block",
        maxWidth: 1280,
        height: "auto",
        maxHeight: 720
      }, t[e.breakpoints.down("lg")] = {
        maxWidth: "100%",
        height: "auto",
        maxHeight: "100%"
      }, t)
    });
  }),
      h = a.memo(function (e) {
    var t,
        r = e.imagePreviewFile,
        o = e.onClose,
        a = e.open,
        l = g();
    return s.createElement(n.Dialog, {
      fullScreen: !0,
      open: a,
      style: {
        zIndex: 1500
      }
    }, s.createElement(s.Fragment, null, s.createElement(n.DialogTitle, {
      className: l.dialogTitle
    }, s.createElement(n.Box, {
      display: "flex",
      justifyContent: "space-between",
      width: 1,
      alignContent: "center",
      alignItems: "center"
    }, s.createElement(n.Box, null, s.createElement(n.Typography, {
      className: l.titleText,
      variant: "body1"
    }, r.name), s.createElement(n.Box, {
      display: "flex"
    }, s.createElement(c.HoverLink, {
      external: !0,
      color: "primary",
      hoverColor: "primary",
      to: (null === (t = r.campfireResource) || void 0 === t ? void 0 : t.url) || "",
      target: "_blank",
      rel: "noopener noreferrer",
      download: r.name
    }, s.createElement(n.Typography, {
      variant: "body2"
    }, "Download Image")), s.createElement(n.Typography, {
      className: l.fileSizeText,
      variant: "body2"
    }, function (e, t, n) {
      void 0 === t && (t = !1), void 0 === n && (n = 1);
      var r = t ? 1e3 : 1024;
      if (Math.abs(e) < r) return e + " B";
      var o = t ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
          a = -1,
          l = Math.pow(10, n),
          i = e;

      do {
        i /= r, ++a;
      } while (Math.round(Math.abs(i) * l) / l >= r && a < o.length - 1);

      return i.toFixed(n) + " " + o[a];
    }(r.size, !0)))), s.createElement(n.IconButton, {
      className: l.closeDialogIconButton,
      onClick: o
    }, s.createElement(u, {
      className: l.titleText
    })))), s.createElement(n.Divider, {
      className: l.divider
    }), s.createElement(n.DialogContent, {
      className: l.dialogContent
    }, s.createElement(n.Box, {
      paddingY: 2,
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center",
      height: "100%"
    }, s.createElement("img", {
      src: r.objectUrl,
      alt: "full-preview",
      className: l.image
    })))));
  }),
      y = o.makeStyles(function (e) {
    return o.createStyles({
      rootFileItemContainer: {
        position: "relative",
        "&:hover $downloadText": {
          color: e.palette.primary.main,
          backgroundColor: "red,"
        }
      },
      rootFileItem: {
        backgroundColor: "#ffffff",
        minHeight: 58,
        borderRadius: 8,
        border: "solid 1px rgba(0, 0, 0, 0.25)",
        "&:hover": {
          backgroundColor: "#fafafa",
          borderColor: "rgba(0, 0, 0, 0.54)"
        }
      },
      icon: {
        color: e.palette.action.disabled
      },
      fileName: {
        maxWidth: 200
      },
      downloadText: {
        color: e.palette.text.secondary,
        position: "absolute",
        bottom: 12,
        left: 60,
        maxWidth: 200,
        textDecoration: "none"
      },
      downloadLink: {
        color: "inherit",
        textDecoration: "none"
      },
      fileWarning: {
        color: e.palette.warning.dark,
        fontSize: "13px"
      }
    });
  }),
      b = o.makeStyles(function (e) {
    return o.createStyles({
      rootItem: {
        marginTop: 8,
        marginRight: 16,
        marginBottom: 8,
        marginLeft: 0,
        "&:hover": {
          cursor: "pointer"
        }
      },
      removeFileButton: {
        backgroundColor: "#242424",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: e.palette.error.main,
          color: "#ffffff"
        }
      }
    });
  }),
      x = a.memo(function (e) {
    var r = e.file,
        o = e.externalLink,
        a = y(),
        l = r.size / 1e6;
    return s.createElement(s.Fragment, null, s.createElement(t.TitularTooltip, {
      description: r.name,
      maxWidth: 720
    }, s.createElement(n.Box, {
      className: a.rootFileItemContainer
    }, s.createElement("a", {
      className: a.downloadLink,
      href: o || r.objectUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      download: o ? void 0 : r.name
    }, s.createElement(n.Box, {
      position: "relative",
      display: "flex",
      className: a.rootFileItem,
      alignContent: "center",
      alignItems: "center"
    }, s.createElement(n.Box, {
      paddingLeft: 1,
      paddingRight: 2
    }, s.createElement(m, {
      className: a.icon,
      fontSize: "large"
    })), s.createElement(n.Box, {
      paddingRight: 2,
      marginTop: "-24px"
    }, s.createElement(n.Typography, {
      className: a.fileName,
      noWrap: !0,
      display: "block",
      variant: "body2"
    }, r.name)))), s.createElement("a", {
      className: a.downloadText,
      href: r.objectUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      download: r.name
    }, s.createElement(c.HoverText, {
      noWrap: !0,
      display: "inline",
      variant: "caption",
      style: {
        color: "inherit"
      },
      hoverColor: "primary"
    }, "Download")))), l > 15 && s.createElement(n.Box, {
      pt: "4px",
      pl: "4px"
    }, s.createElement(n.Typography, {
      className: a.fileWarning
    }, "File too large. 15MB limit")));
  }),
      v = a.memo(function (e) {
    var r = e.children,
        o = e.onRemoveClick,
        a = b();
    return s.createElement(n.Box, {
      className: a.rootItem
    }, s.createElement(n.Box, {
      position: "relative",
      height: "100%"
    }, r, s.createElement(t.TitularTooltip, {
      placement: "top",
      description: "Remove attachment",
      enterDelay: 500
    }, s.createElement(n.Box, {
      position: "absolute",
      top: -9,
      right: -9
    }, s.createElement(n.IconButton, {
      className: a.removeFileButton,
      size: "small",
      onClick: o
    }, s.createElement(u, {
      fontSize: "small",
      style: {
        fontSize: 12
      }
    }))))));
  }),
      E = a.memo(function (e) {
    var r = e.file,
        o = a.useState(!1),
        l = o[0],
        i = o[1];
    return s.createElement(s.Fragment, null, s.createElement(t.TitularTooltip, {
      description: r.name
    }, s.createElement(n.Box, {
      display: "flex",
      alignContent: "center",
      alignItems: "center",
      overflow: "hidden",
      height: "100%",
      bgcolor: "#f6f8f9",
      border: "solid 1px rgba(0, 0, 0, 0.25)",
      borderRadius: 8,
      minWidth: 58,
      justifyContent: "center",
      onClick: function onClick(e) {
        e.stopPropagation(), i(!0);
      }
    }, s.createElement("img", {
      src: r.objectUrl,
      alt: "thumbnail-preview",
      style: {
        display: "block",
        maxWidth: 200,
        height: "auto",
        maxHeight: 58
      }
    }))), s.createElement(h, {
      imagePreviewFile: r,
      onClose: function onClose() {
        return i(!1);
      },
      open: l
    }));
  }),
      B = o.makeStyles(function (e) {
    return o.createStyles({
      root: {
        position: "relative",
        outline: "none"
      },
      addFileButton: {
        outline: "none",
        border: "dashed 1px #323232",
        borderRadius: 8,
        "&:hover": {
          cursor: "pointer",
          borderColor: e.palette.primary.light
        },
        "&:hover $addFileButtonIcon": {
          color: e.palette.primary.main
        }
      },
      addFileButtonIcon: {
        fontSize: 16
      }
    });
  }),
      k = a.memo(function () {
    return s.createElement(n.Box, {
      style: {
        boxSizing: "border-box"
      },
      position: "absolute",
      width: 1,
      height: 1
    }, s.createElement(n.Box, {
      display: "flex",
      flex: "1 1 auto",
      width: 1,
      height: 1,
      bgcolor: "rgba(255,255,255,0.7)",
      borderRadius: 8,
      border: "dashed 2px mediumspringgreen",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center"
    }, s.createElement(n.Typography, {
      variant: "body2",
      color: "textSecondary"
    }, "Drop file to attach")));
  }),
      C = a.memo(function (e) {
    var o = e.uploadedFiles,
        c = e.allowMultiple,
        u = e.handleFilesAdded,
        m = e.handleFileRemoved,
        g = e.viewOnly,
        h = e.id,
        y = e.accept,
        C = a.useState([]),
        T = C[0],
        I = C[1],
        j = a.useState(null),
        F = j[0],
        N = j[1],
        S = a.useMemo(function () {
      return c || !c && T.length <= 1;
    }, [c, T]),
        R = a.useCallback(function (e) {
      N(null);
      var t = e.map(function (e) {
        return Object.assign(e, {
          id: i.v4(),
          objectUrl: URL.createObjectURL(e)
        });
      });
      u && u(t), I(c ? function (e) {
        return e.concat(t);
      } : t);
    }, [I, u]),
        z = a.useCallback(function () {
      N("File type not accepted. Please upload a valid file.");
    }, []);

    var D = function D(e) {
      return f(void 0, void 0, void 0, function () {
        return p(this, function (t) {
          return [2, Promise.all(e.map(function (e) {
            return function (e) {
              return f(this, void 0, void 0, function () {
                return p(this, function (t) {
                  switch (t.label) {
                    case 0:
                      return [4, fetch(e.url).then(function (e) {
                        return e.blob();
                      }).then(function (t) {
                        return new File([t], e.name, {
                          type: t.type
                        });
                      })];

                    case 1:
                      return [2, {
                        file: t.sent(),
                        originalUrl: e.url,
                        fileId: e.fileId
                      }];
                  }
                });
              });
            }(e);
          }))];
        });
      });
    };

    a.useEffect(function () {
      D(o).then(function (e) {
        if (e.length && S) {
          var t = e.map(function (e) {
            return Object.assign(e.file, {
              id: e.fileId,
              objectUrl: URL.createObjectURL(e.file),
              campfireResource: {
                fileId: e.fileId,
                url: e.originalUrl
              }
            });
          });
          I(t);
        }
      });
    }, [o]);
    var L = l.useDropzone({
      onDrop: S ? R : void 0,
      onDropRejected: z,
      noClick: !0,
      accept: y || "image/*, .heic, .heif, .bz, .bz2, .csv, .doc, .docx, .gz, .json, .jsonld, .odp, .ods, .odt, .pdf, .ppt, .pptx, .rar, .rtf, .svg, .tar, .txt, .xls, .xlsx, .xml, .zip, .7z"
    }),
        U = L.getRootProps,
        P = L.getInputProps,
        O = L.isDragActive,
        W = L.open,
        q = b(),
        M = B();
    return g ? s.createElement(w, {
      isLoading: o.length !== T.length,
      files: T
    }) : s.createElement(s.Fragment, null, s.createElement("div", _d({}, U(), {
      className: M.root,
      id: h
    }), s.createElement("input", _d({}, P())), O && S ? s.createElement(k, null) : null, s.createElement(n.Box, {
      display: "flex",
      flexWrap: "wrap"
    }, T.map(function (e, t) {
      var n = function n() {
        m && m(e), I(function (e) {
          return e.filter(function (e, n) {
            return n !== t;
          });
        });
      };

      return e.type.includes("image") ? s.createElement(v, {
        onRemoveClick: n,
        key: e.objectUrl
      }, s.createElement(E, {
        file: e
      })) : s.createElement(v, {
        key: e.objectUrl,
        onRemoveClick: n
      }, s.createElement(x, {
        file: e
      }));
    }), s.createElement(n.Box, {
      className: q.rootItem
    }, S ? s.createElement(t.TitularTooltip, {
      title: T.length > 0 ? "Add another attachment" : "Add an attachment",
      description: "Attach a File from Your Computer"
    }, s.createElement("button", {
      className: M.addFileButton,
      type: "button",
      onClick: W
    }, s.createElement(n.Box, {
      height: 58,
      minWidth: 58,
      display: "flex",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      paddingX: 2
    }, s.createElement(r, {
      className: M.addFileButtonIcon
    }), s.createElement(n.Typography, {
      style: {
        paddingLeft: 12
      },
      variant: "body2",
      color: "textSecondary"
    }, "Attach a File from Your Computer")))) : null))), F && s.createElement(n.Typography, {
      variant: "caption",
      style: {
        color: "#c62828",
        marginTop: 4,
        display: "block"
      }
    }, F));
  }),
      w = a.memo(function (e) {
    var t = e.files,
        r = e.isLoading,
        o = b();
    return s.createElement(n.Box, {
      display: "flex",
      flexWrap: "wrap"
    }, t.length > 0 ? t.map(function (e) {
      return e.type.includes("image") ? s.createElement(n.Box, {
        key: e.objectUrl,
        className: o.rootItem
      }, s.createElement(E, {
        file: e
      })) : s.createElement(n.Box, {
        key: e.objectUrl,
        className: o.rootItem
      }, s.createElement(x, {
        file: e,
        externalLink: e.campfireResource ? e.campfireResource.url : void 0
      }));
    }) : r ? s.createElement(n.Box, {
      minHeight: 79,
      paddingX: 3,
      display: "flex",
      alignContent: "center",
      alignItems: "center"
    }, s.createElement(n.LinearProgress, {
      style: {
        width: 128,
        height: 3
      }
    })) : s.createElement(s.Fragment, null, "Nothing to show"));
  });
  e.FileUploadGallery = C, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});